exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".description-block[data-v-28d65e8b]{border-left:0}@media (min-width:576px){.description-block[data-v-28d65e8b]{border-left:.125rem solid #fff}}.product-information[data-v-28d65e8b]{background-color:#f7f7f7}@media (max-width:991.98px){.product-information[data-v-28d65e8b]{margin-bottom:.5rem}}", ""]);

